import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import Typography from '@mui/material/Typography';
//import Sheet from '@mui/material/Sheet';
import FormControl from '@mui/material/FormControl';
//import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Select from '@mui/material/Select';
//import Option from '@mui/material/Option';
import MenuItem from '@mui/material/MenuItem';
//import FormHelperText from '@mui/material/FormHelperText';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { visuallyHidden } from '@mui/utils';

import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';

import Documentos from './Documentos';
import ChipSatge from './Elements/ChipSatge';

import { JsonToExcel } from "react-json-to-excel";

let rows = [];

function labelDisplayedRows({ from, to, count }) {
    return `${from}–${to} de ${count !== -1 ? count : `más de ${to}`}`;
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}


const headCells = [
    {
        id: 'Expediente',
        numeric: false,
        disablePadding: true,
        label: 'Expediente',
    },
    {
        id: 'Name',
        numeric: false,
        disablePadding: true,
        label: 'Operación',
    },
    {
        id: 'id_oferta',
        numeric: false,
        disablePadding: true,
        label: '',
    },
    {
        id: 'Closing_Date',
        numeric: true,
        disablePadding: false,
        label: 'Fecha \n inversión',
    },
    {
        id: 'Porcentaje',
        numeric: true,
        disablePadding: false,
        label: 'Participación',
    },
    {
        id: 'Ticket_op',
        numeric: true,
        disablePadding: false,
        label: 'Importe \n invertido',
    },
    {
        id: 'Periodo',
        numeric: true,
        disablePadding: false,
        label: 'Periodo \n restante',
    },
    {
        id: 'TIR_Objetivo',
        numeric: true,
        disablePadding: false,
        label: 'Tipo interés \n objetivo',
        info: 'El tipo de interés bruto anual estimado para el  inversor, excluyendo comisiones y pérdidas estimadas.',
    },
    {
        id: 'Rendimiento_anual',
        numeric: true,
        disablePadding: false,
        label: 'Rendimiento \n Anual Bruto',
        info: 'Rentabilidad anual de las operaciones en alquiler antes de deducir los gastos o impuestos relacionados con la transacción.',
    },
    {
        id: 'Beneficio_optante',
        numeric: true,
        disablePadding: false,
        label: 'Beneficio \n objetivo',
    },
    {
        id: 'Fecha_cancelacion',
        numeric: true,
        disablePadding: false,
        label: 'Fecha cancelación \n objetivo',
    },
    {
        id: 'Estado',
        numeric: true,
        disablePadding: false,
        label: 'Estado',
    },
];

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <thead>
            <tr>
                {headCells.map((headCell) => {
                    const active = orderBy === headCell.id;
                    return (
                        <th
                            key={headCell.id}
                            aria-sort={
                                active ? { asc: 'ascending', desc: 'descending' }[order] : undefined
                            }
                        >
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <Link
                                underline="none"
                                color="neutral"
                                textcolor={active ? 'primary.plainColor' : undefined}
                                component="button"
                                onClick={createSortHandler(headCell.id)}
                                fontWeight="lg"
                                sx={{
                                    whiteSpace: 'pre',
                                    '& svg.colArrow': {
                                        transition: '0.2s',
                                        transform:
                                            active && order === 'desc' ? 'rotate(0deg)' : 'rotate(180deg)',
                                    },
                                    '&:hover': { '& svg': { opacity: 1 } },
                                }}
                            >
                                {headCell.info ?
                                <Tooltip placement="right-start" title={headCell.info}><InfoOutlined sx={{ fontSize: 14, mr: 0.5 }} /> 
                                </Tooltip> : null}
                                {headCell.label} <ArrowDownwardIcon className="colArrow" sx={{ opacity: active ? 1 : 0, fontSize: 14 }} />
                                {active ? (
                                    <><Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                    
                                    </>
                                ) : null}
                                
                            </Link>
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

function creaJsonExport() {
    let jsonExport = [];
    rows.forEach(row => {
        jsonExport.push({
            "Expediente": row.Expediente,
            "Operación": row.Name,
            "Fecha inversión": row.Closing_Date,
            "Participación": row.Porcentaje,
            "Importe invertido": row.Ticket_op,
            "Periodo restante": row.Periodo,
            "Tipo interés objetivo": row.TIR_Objetivo,
            "Rendimiento bruto anual": row.Rendimiento_anual,
            "Beneficio objetivo": row.Beneficio_optante,
            "Fecha cancelacion objetivo": row.Fecha_cancelacion,
            "Estado": row.Stage,
        });
    });
    return jsonExport;
}

export default function TableEnCurso(props) {

    rows = props.rows;

    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('Closing_Date');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.id);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const handleChangePage = (newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event, newValue) => {
        //console.log(newValue);
        setRowsPerPage(parseInt(newValue.props.value, 10));
        setPage(0);
    };

    const getLabelDisplayedRowsTo = () => {
        if (rows.length === -1) {
            return (page + 1) * rowsPerPage;
        }
        return rowsPerPage === -1
            ? rows.length
            : Math.min(rows.length, (page + 1) * rowsPerPage);
    };

    const isSelected = (id) => selected.indexOf(id) !== -1;

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    return (
        <>
            <JsonToExcel
                title="Descargar Excel"
                data={creaJsonExport()}
                fileName="Ondara - Inversiones en curso"
                btnClassName="pclp-btn-excel"
            />

            <Table className="pclp-table-investments"
                aria-labelledby="tableTitle"
                sx={{
                    'width': '100%',
                }}
            >
                <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={rows.length}
                />
                <tbody>
                    {rows.slice().sort(getComparator(order, orderBy))
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row, index) => {
                            const isItemSelected = isSelected(row.id_oferta);
                            const labelId = `enhanced-table-row-${index}`;

                            //setJsonExport(rows);

                            return (
                                <tr
                                    onClick={(event) => handleClick(event, row.id_oferta)}
                                    role="checkbox"
                                    aria-checked={isItemSelected}
                                    tabIndex={-1}
                                    key={row.id_oferta}
                                >
                                    <td id={labelId}>
                                        {row.Expediente}
                                    </td>
                                    <td>{row.Name}</td>
                                    <td><Documentos id_oferta={row.id_oferta} id_producto={row.id_producto} Tipo_Producto={row.Tipo_Producto} {...props} /></td>
                                    <td>{row.Closing_Date}</td>
                                    <td>{row.Porcentaje.toLocaleString(navigator.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%</td>
                                    <td>{row.Ticket_op.toLocaleString(navigator.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}€</td>
                                    <td>{ row.Periodo !== 0 ? row.Periodo+' meses' : '-'}</td>
                                    <td><span className="pclp-highlight">{ row.TIR_Objetivo !==0 ? row.TIR_Objetivo.toLocaleString(navigator.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 })+'%' : '-'}</span></td>
                                    <td><span className="pclp-highlight">{ row.Rendimiento_anual !== '-' ? row.Rendimiento_anual.toLocaleString(navigator.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 })+'%' : '-'}</span></td>
                                    <td><span className="pclp-highlight">{ row.Beneficio_optante !== 0 ? row.Beneficio_optante.toLocaleString(navigator.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 })+'€' : '-'}</span></td>
                                    <td>{row.Fecha_cancelacion !== '0' ? row.Fecha_cancelacion : '-'}</td>
                                    <td><ChipSatge stage={row.Stage} estado={row.Estado} Detalle_estado={row.Detalle_estado} Tipo_Producto={row.Tipo_Producto} /></td>
                                </tr>
                            );
                        })}
                    {emptyRows > 0 && (
                        <tr
                            style={{
                                height: `calc(${emptyRows} * 40px)`,
                                '--TableRow-hoverBackground': 'transparent',
                            }}
                        >
                            <td colSpan={11} aria-hidden />
                        </tr>
                    )}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={5}>
                        <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 2,
                                    justifyContent: 'flex-start',
                                }}
                            >
                                Mostrar
                                <FormControl variant="standard" >
                                    <Select onChange={handleChangeRowsPerPage} value={rowsPerPage}>
                                        <MenuItem value={10}>10</MenuItem>
                                        <MenuItem value={25}>25</MenuItem>
                                        <MenuItem value={50}>50</MenuItem>
                                    </Select>
                                </FormControl>
                                filas
                            </Box>
                            </td>
                            <td colSpan={6}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 2,
                                    justifyContent: 'flex-end',
                                }}
                            >
                                <Typography textAlign="center" sx={{ minWidth: 80 }}>
                                    {labelDisplayedRows({
                                        from: rows.length === 0 ? 0 : page * rowsPerPage + 1,
                                        to: getLabelDisplayedRowsTo(),
                                        count: rows.length === -1 ? -1 : rows.length,
                                    })}
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <IconButton
                                        size="sm"
                                        color="neutral"
                                        variant="outlined"
                                        disabled={page === 0}
                                        onClick={() => handleChangePage(page - 1)}
                                        sx={{ bgcolor: 'background.surface' }}
                                    >
                                        <KeyboardArrowLeftIcon />
                                    </IconButton>
                                    <IconButton
                                        size="sm"
                                        color="neutral"
                                        variant="outlined"
                                        disabled={
                                            rows.length !== -1
                                                ? page >= Math.ceil(rows.length / rowsPerPage) - 1
                                                : false
                                        }
                                        onClick={() => handleChangePage(page + 1)}
                                        sx={{ bgcolor: 'background.surface' }}
                                    >
                                        <KeyboardArrowRightIcon />
                                    </IconButton>
                                </Box>
                            </Box>
                        </td>
                    </tr>
                </tfoot>
            </Table>
        
        </>
    );
}
